import { DateTime } from "luxon";

export const dateFromTimestamp = ({ date, format = "dd/MM/yyyy HH:mm" }) =>
  DateTime.fromMillis(parseInt(date)).toFormat(format);
